import {isPlatformBrowser} from "@angular/common";
import {Config} from "../common/config";

export class SessionStorageUtil {
  public static saveString(key: string, value: string): void {
    if (isPlatformBrowser(Config.platformId)) {
      sessionStorage.setItem(key, value);
    }
  }

  public static saveInt(key: string, value: number): void {
    if (isPlatformBrowser(Config.platformId)) {
      sessionStorage.setItem(key, '' + value);
    }
  }

  public static saveBoolean(key: string, value: boolean): void {
    if (isPlatformBrowser(Config.platformId)) {
      sessionStorage.setItem(key, '' + value);
    }
  }

  public static saveObject(key: string, value: any): void {
    if (isPlatformBrowser(Config.platformId)) {
      sessionStorage.setItem(key, JSON.stringify(value));
    }
  }

  public static loadString(key: string, defaultValue: string | null): string | null {
    if (isPlatformBrowser(Config.platformId)) {
      return sessionStorage.getItem(key) == null ? defaultValue : sessionStorage.getItem(key);
    }
    return defaultValue;
  }

  public static loadInt(key: string, defaultValue: number): number | null {
    if (isPlatformBrowser(Config.platformId)) {
      return sessionStorage.getItem(key) == null ? defaultValue : JSON.parse(<string>sessionStorage.getItem(key));
    }
    return defaultValue;
  }

  public static loadBoolean(key: string, defaultValue: boolean): boolean | null {
    if (isPlatformBrowser(Config.platformId)) {
      return sessionStorage.getItem(key) == null ? defaultValue : JSON.parse(<string>sessionStorage.getItem(key));
    }
    return defaultValue;
  }

  public static loadObject(key: string, defaultValue: any): any | null {
    if (isPlatformBrowser(Config.platformId)) {
      return sessionStorage.getItem(key) == null ? defaultValue : JSON.parse(<string>sessionStorage.getItem(key));
    }
    return defaultValue;
  }

  public static remove(key: string): void {
    if (isPlatformBrowser(Config.platformId)) {
      return sessionStorage.removeItem(key);
    }
  }

  public static clear(): void {
    if (isPlatformBrowser(Config.platformId)) {
      sessionStorage.clear();
    }
  }
}
